import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { SkeletonBlock, SkeletonGroup, SkeletonLine } from "../utility/skeleton"
import { MAX_CONTENT_WIDTH } from "../config"

type Props = {
  logoSize?: number
}

export const CompanyProfileSkeleton = ({ logoSize = 150 }: Props): React.ReactElement => {
  const { theme } = useContext(ThemeContext)
  const { bgMain } = theme.colors

  return (
    <View style={{ flex: 1, backgroundColor: bgMain }}>
      <View
        style={[styles.content, { maxWidth: MAX_CONTENT_WIDTH }]}
      >
        <SkeletonGroup>
          {/* Header row */}
          <View style={styles.headerRow}>
            {/* Logo */}
            <SkeletonBlock
              style={[styles.logo, { width: logoSize, height: logoSize }]}
              radius={16}
            />
            {/* Header text */}
            <View style={{ flex: 1, gap: 10, paddingTop: 8, minWidth: 250 }}>
              {/* Name */}
              <SkeletonLine width="75%" height={22} radius={10} />
              {/* Category */}
              <SkeletonLine width="55%" height={14} radius={10} />
              {/* HQ */}
              <SkeletonLine width="65%" height={14} radius={10} />
              {/* Website */}
              <SkeletonLine width="65%" height={14} radius={10} />
            </View>
          </View>

          {/* Content Estimate */}
          <SkeletonBlock
            style={[styles.section, { height: 160 }]}
            radius={16}
          />

          {/* Disclaimer / feedback lines */}
          <View style={{ gap: 8, marginTop: 10 }}>
            <SkeletonLine width="95%" height={12} radius={8} />
            <SkeletonLine width="92%" height={12} radius={8} />
            <SkeletonLine width="60%" height={12} radius={8} />
          </View>
        </SkeletonGroup>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  content: {
    alignSelf: "center",
    width: "100%",
    padding: 10,
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: 18,
  },
  headerRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "flex-start",
    justifyContent: "center",
  },
  logo: {
    width: 150,
    height: 150,
  },
  section: {
    width: "100%",
    height: 160,
  },
})

